import { type RefObject, useEffect, useSyncExternalStore } from 'react'

import { LANDSCAPE_BOTTOM_NAV_MEDIA } from './const'

const isEditableTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) return false

  if (target.isContentEditable) return true

  const tagName = target.tagName

  return tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT'
}

export const useJumpToMainNavigation = (firstLinkRef: RefObject<HTMLAnchorElement | null>) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!event.altKey || event.code !== 'KeyM') return
      if (event.ctrlKey || event.shiftKey) return
      if (isEditableTarget(event.target)) return

      event.preventDefault()

      firstLinkRef.current?.focus()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [firstLinkRef])
}

const REDUCED_MOTION_MEDIA = '(prefers-reduced-motion: reduce)'

export const usePrefersReducedMotion = () =>
  useSyncExternalStore(
    onChange => {
      const reducedMotionMediaQueryList = window.matchMedia(REDUCED_MOTION_MEDIA)

      reducedMotionMediaQueryList.addEventListener('change', onChange)

      return () => reducedMotionMediaQueryList.removeEventListener('change', onChange)
    },
    () => window.matchMedia(REDUCED_MOTION_MEDIA).matches,
    () => false,
  )

export const useLandscapeBottomNavLayout = () =>
  useSyncExternalStore(
    onChange => {
      const landscapeBottomNavMediaQueryList = window.matchMedia(LANDSCAPE_BOTTOM_NAV_MEDIA)

      landscapeBottomNavMediaQueryList.addEventListener('change', onChange)

      return () => landscapeBottomNavMediaQueryList.removeEventListener('change', onChange)
    },
    () => window.matchMedia(LANDSCAPE_BOTTOM_NAV_MEDIA).matches,
    () => false,
  )
